import {useListView} from '../../core/ListViewProvider'
import {BookingsListToolbar} from './BookingListToolbar'
import {BookingsListGrouping} from './BookingsListGrouping'
import {BookingsListSearchComponent} from './BookingsListSearchComponent'

const BookingsListHeader = () => {
  const {selected} = useListView()
  return (
    <div className='bookingd-header d-flex justify-content-between px-10 border-0 pt-6'>
      <BookingsListSearchComponent />
      {/* begin::Bookingd toolbar */}
      <div className='bookingd-toolbar'>
        {/* begin::Group actions */}
        {selected.length > 0 ? <BookingsListGrouping /> : <BookingsListToolbar />}
        {/* end::Group actions */}
      </div>
      {/* end::Bookingd toolbar */}
    </div>
  )
}

export {BookingsListHeader}
